<template>
  <div
    class="attendance-list-row-no-photo double-column"
  >
    <div
      :id="'student-row-' + studentId"
      style="min-width:5px; height:inherit;"
      :style="{ 'background-color':backgroundLeft }"
    />
    <div
      class="row attendance-list-row"
      :style="{ 'background-color':attendanceColor }"
      style=""
    >
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 row-name">
        <div class="awesome-checkbox">
          <div
            class="checkbox checkbox-attendance-list"
            style="margin:0px"
          >
            <input
              :id="uniqueAttendanceId"
              type="checkbox"
              :checked="attended"
              class="student_checkbox"
              :disabled="disabled"
              @click="changeAttendance"
            >
            <label :for="uniqueAttendanceId">{{ student.attributes.name }}
              <span
                v-if="stopDate != null && !useOnSmartBoard"
                v-tooltip.bottom-center="trans('core.stopped_per', { date: stopDate })"
                class="fa fa-ban"
                data-placement="bottom"
                style="color:#b71c1c"
              />
            </label>
          </div>
        </div>
      </div>

      <div
        v-if="!useOnSmartBoard"
        class="col-xs-6 col-sm-6 col-md-6"
        style="padding:0px;"
      >
        <!--dropdowns-->
        <div
          v-if="hasDropdowns"
          class="pull-right context-dropdown"
          :class="dropClass"
        >
          <a
            class="menu-button menu-button-no-photo"
            href="#"
            aria-hidden="true"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
            style=""
          >
            <i
              class="fa fa-ellipsis-v fa-lg"
              style="color:black; margin-top:10px;"
            />
          </a>
          <ul class="dropdown-menu dropdown-menu-right">
            <li
              v-for="dropdown in dropdowns"
              class="additional-contexts"
              @click="changeContext(dropdown)"
            >
              <span>
                <a
                  href="#"
                  class="add-context"
                  title="dropdownLabel"
                >
                  <span class="test">{{ trans('attendance_list.contexts.' + dropdown) }}</span>
                  <span
                    style="margin-top: 2px; margin-right:5px; margin-left: 5px;"
                    :class="'pull-right' + checked(dropdown)"
                  />
                </a>
              </span>
            </li>

            <template v-if="free_remark_dropdown || minutesMissing.enabled">
              <li
                v-if="dropdowns.length > 0"
                class="divider"
              />

              <template v-if="minutesMissing.enabled">
                <li
                  v-for="contextLabel in minutesMissing.context_labels"
                  class="additional-contexts"
                  @click="openMinutesModal(contextLabel)"
                >
                  <span>
                    <a
                      href="#"
                      class="add-context"
                      title="dropdownLabel"
                    >
                      <span>{{ trans('attendance_list.contexts.' + contextLabel) }}</span>
                      <span
                        :class="'pull-right ' + checked(contextLabel)"
                        style="margin-top: 2px; margin-right:5px; margin-left: 5px;"
                      /><span v-if="checked(contextLabel)">({{ selectedMinutesContext(contextLabel) }})</span>
                    </a>
                  </span>
                </li>
              </template>

              <li
                v-if="free_remark_dropdown"
                class="additional-contexts"
                @click="openRemarkModal"
              >
                <span>
                  <a
                    href="#"
                    class="add-context"
                    title="dropdownLabel"
                  >
                    <span>{{ trans('attendance_list.contexts.free_remark') }}</span>
                    <span
                      :class="'pull-right ' + icons['free_remark'] + (remark_count > 0 ? ' fa-icon-badge badge-dropdown' : '')"
                      :data-count="remark_count"
                      style="margin-top: 2px; margin-right:5px; margin-left: 5px;"
                    />
                  </a>
                </span>
              </li>
            </template>
          </ul>
        </div>

        <span
          v-for="(icon, index) in icons"
          v-if="iconSet(index)"
          data-v-step="additional_info"
          class="attendance-icon pull-right"
          style="padding: 0px; margin-right:25px;"
        >
          <span
            :class="iconClass(icon, index)"
            :data-count="getDataCount(index)"
            :style="'cursor: pointer; ' + (checked(index) ? 'color: black;' : 'color: #dedede;')"
            @click="iconClicked(index)"
          />
        </span>
      </div>
    </div>

    <attendance-list-remark-modals
      v-if="remarkModal"
      :student-id="studentId"
      :course-id="courseId"
      :lesson-id="lessonId"
      @closed-modal="closeRemarkModal"
    />

    <attendance-list-minutes-modal
      v-if="minutesModal"
      :student-id="studentId"
      :course-id="courseId"
      :lesson-id="lessonId"
      :context-label="minutesContextActive"
      :minutes="selectedMinutesContext(minutesContextActive)"
      @closed-modal="closeMinutesModal"
    />
  </div>
</template>

<script>

import AttendanceListRemarkModals from './AttendanceListRemarkModals.vue'
import AttendanceListMinutesModal from './AttendanceListMinutesModal.vue'
import { defaultErrorMessage } from '@/helpers'
import { PERMITTED_ABSENT } from '@/constants'

export default {

  name: 'AttendanceListRow',

  components: { AttendanceListMinutesModal, AttendanceListRemarkModals },

  props: {
    courseId: {
      required: true,
      type: String,
    },
    lessonId: {
      required: true,
      type: String,
    },
    studentId: {
      required: true,
      type: String,
    },
    disabledBySelectAll: {
      type: Boolean,
      default: false,
    },
    dropClass: {
      required: false,
      type: String,
      default: 'dropdown',
    },
    useOnSmartBoard: {
      required: false,
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      disabled: this.disabledBySelectAll,
      remarkModal: false,
      minutesModal: false,
      minutesContextActive: null,
    }
  },

  computed: {
    attended () {
      return this.$store.state.attendancelist.attendances.studentIds.includes(this.studentId)
    },
    unexpected () {
      return this.$store.state.attendancelist.unexpectedStudentIds.studentIds.includes(Number(this.studentId))
    },
    student () {
      return this.$store.state.attendancelist.students[String(this.studentId)]
    },
    stopDate () {
      return this.student.attributes.stop_date
    },
    contexts () {
      return this.student.relationships.contexts.data
    },
    contextTypes () {
      let self = this
      return this.contexts.map(function (context) {
        return self.$store.state.attendancelist.contexts[context.id].attributes.type
      })
    },
    icons () {
      return this.$store.state.attendancelist.contextLabels.icons
    },
    dropdowns () {
      const dropdowns = Object.values(this.$store.state.attendancelist.contextLabels.dropdowns)

      if (this.minutesMissing.enabled) {
        return dropdowns.filter(dropdown => !this.minutesMissing.context_labels.includes(dropdown))
      }

      return dropdowns
    },
    hasDropdowns () {
      return Object.keys(this.$store.state.attendancelist.contextLabels.dropdowns).length > 0
    },
    free_remark_icon () {
      return this.$store.state.attendancelist.contextLabels.free_remark_icon
    },
    free_remark_dropdown () {
      return this.$store.state.attendancelist.contextLabels.free_remark_dropdown
    },
    remarkSecondAction () {
      return this.free_remark_icon && Object.keys(this.icons)[1] === 'free_remark'
    },
    remark_count () {
      return this.contextTypes.filter(function (item) {
        return item === 'free_remark'
      }).length
    },
    backgroundLeft () {
      if (this.attended) {
        return 'green'
      } else if (this.reportedAbsent) {
        return 'red'
      } else if (this.permittedAbsent) {
        return 'blue'
      } else if (Object.keys(this.contexts).length > 0 && !this.useOnSmartBoard) {
        return 'gray'
      } else {
        return 'white'
      }
    },
    attendanceColor () {
      if (this.attended && this.unexpected) {
        return '#dcfcd7'
      } else if (this.attended) {
        return '#a3fc95'
      } else if (this.reportedAbsent) {
        return '#fca99f'
      } else if (this.permittedAbsent) {
        return '#82A0FC'
      } else if (Object.keys(this.contexts).length > 0 && !this.useOnSmartBoard) {
        return 'lightgray'
      } else {
        return 'white'
      }
    },
    uniqueAttendanceId () {
      return 'attendance_check_' + this.studentId
    },
    attendanceListEnabled () {
      return this.$store.state.attendancelist.registrationAvailable
    },
    minutesMissing () {
      return this.$store.state.attendancelist.minutesMissingConfig
    },
    reportedAbsent () {
      return this.contextTypes.includes('reported_absent')
    },
    permittedAbsent () {
      return this.contextTypes.includes(PERMITTED_ABSENT)
    },
  },

  watch: {
    disabledBySelectAll: function (val) {
      this.disabled = val
    },
  },

  mounted () {},

  methods: {
    checked (value) {
      return Object.values(this.contextTypes).includes(value) ? ' fa fa-check' : ''
    },
    selectedMinutesContext (value) {
      const contextIds = Object.values(this.contexts).map(context => context.id)
      const selectedContext = Object.values(this.$store.state.attendancelist.contexts).find(context => contextIds.includes(context.id) && context.attributes.type === value)

      return selectedContext == null ? null : selectedContext.attributes.remark
    },
    iconSet (value) {
      return value !== 'free_remark' || (value === 'free_remark' && this.free_remark_icon)
    },
    iconClass (icon, index) {
      return icon + ' fa-2x' + ((index === 'free_remark' || this.isMinutesMissing(index)) && this.getDataCount(index) > 0 ? ' fa-icon-badge' : '')
    },
    isMinutesMissing (inputLabel) {
      if (this.minutesMissing.enabled === false) {
        return false
      }
      return this.minutesMissing.context_labels.some(label => label === inputLabel)
    },
    getDataCount (inputLabel) {
      if (inputLabel === 'free_remark') {
        return this.remark_count
      } else if (this.isMinutesMissing(inputLabel)) {
        return this.selectedMinutesContext(inputLabel)
      } else {
        return ''
      }
    },
    iconClicked (input) {
      if (input === 'free_remark') {
        return this.openRemarkModal()
      } else if (this.isMinutesMissing(input)) {
        return this.openMinutesModal(input)
      } else {
        return this.changeContext(input)
      }
    },
    changeAttendance (e) {
      let data = {
        courseId: this.courseId,
        lessonId: this.lessonId,
        studentIds: [this.studentId],
        attended: this.attended,
        unexpected: false,
      }

      if (!this.attendanceListEnabled) {
        this.$emit('attendanceRegistrationAttemptWhenDisabled', data)
        e.stopPropagation()
        e.preventDefault()
        return false
      }

      this.$store.dispatch('change_loading', { loading: true }).then(() => {
        this.disabled = true

        return this.$store.dispatch('change_attendance', data).catch(error => defaultErrorMessage(error))
      }).then(() => {
        this.disabled = false
        this.$store.dispatch('change_loading', { loading: false })
      })
    },
    changeContext (contextType) {
      this.$store.dispatch('change_loading', { loading: true }).then(() => {
        return this.$store.dispatch('change_context', {
          courseId: this.courseId,
          lessonId: this.lessonId,
          studentId: this.studentId,
          contextType: contextType,
          checked: this.checked(contextType) !== '',
          remark: null,
        }).catch(error => defaultErrorMessage(error))
      }).then(() => {
        this.$store.dispatch('change_loading', { loading: false })
      })
    },
    openRemarkModal () {
      this.remarkModal = true
    },
    closeRemarkModal () {
      this.remarkModal = false
    },
    openMinutesModal (contextlabel) {
      this.minutesContextActive = contextlabel
      this.minutesModal = true
    },
    closeMinutesModal () {
      this.minutesModal = false
    },
  },
}
</script>

<style scoped>
    hr {
        padding: 0;
        margin: 0;
    }

    li:hover {
        cursor: pointer;
    }

    li:hover a {
        color: red;
    }

    .attendance-list-row-no-photo {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-left: 0;
    }

    .attendance-list-row {
        border: 1px solid;
        padding: 10px 5px;
        border-color: #ddd;
        margin: 0px !important;
        width: 100%;
        align-items: center;
        display: flex;
    }

    .menu-button-no-photo {
        float: right;
        padding-right: 10px;
        text-align: center;
        padding-left: 10px;
    }

    .dropdown-menu-right {
        margin-right: 20px;
        margin-top: 10px;
        z-index: 9999;
    }

    .attendance-icon {
        display: inline-block;
    }

    .fa-icon-badge:after {
        content: attr(data-count);
        position: absolute;
        font-family: Roboto, Helvetica, Arial, sans-serif;
        background: rgba(0, 0, 0, 1);
        height: 1.5rem;
        margin-left:-5px;
        top: 1.5rem;
        width: 1.5rem;
        padding-right: 0.2rem;
        padding-left: 0.1rem;
        text-align: center;
        line-height: 1.3rem;
        font-size: 1.0rem;
        border-radius: 50%;
        color: white;
        border: 1px solid rgba(0, 0, 0, 1);
    }

    .icon-badge-left:after {
        right: 7rem;
    }

    .badge-dropdown:after {
        right: 0.6rem;
    }

    .checkbox label {
        user-select: none;
    }

    .awesome-checkbox, .checkbox, .checkbox label {
        cursor: pointer;
    }

    .double-column {
      max-height: 150px;
      display:flex;
      flex-direction:row;
      width:100%;
    }

    @media only screen and (min-width: 1300px) {
      .double-column {
        width:50% !important;
      }
    }
</style>
